import { RPCDocs } from "../../../services/rpc.js";
//#region src/modules/ServicePeriods/calendar/build-visible-range-query.ts
function resolveLocationIds(input) {
	if (input.locationIds?.length) return input.locationIds;
	if (input.locationId) return [input.locationId];
}
function buildVisibleRangeQuery(input) {
	const Sort = RPCDocs.ServicePeriods.FindServicePeriodInstances.v1.Sort;
	const rangeEndIso = new Date(input.toMs).toISOString();
	const rangeStartIso = new Date(input.fromMs).toISOString();
	const locationIds = resolveLocationIds(input);
	const startsAtLt = input.rangeMode === "history" && input.nowIso < rangeEndIso ? input.nowIso : rangeEndIso;
	return {
		endsAt: { gt: input.rangeMode === "upcoming" && input.nowIso > rangeStartIso ? input.nowIso : rangeStartIso },
		...locationIds ? { locationIds } : {},
		pagination: {
			limit: 500,
			skip: 0
		},
		...input.regionIds?.length ? { regionIds: input.regionIds } : {},
		...input.servicePeriodIds?.length ? { servicePeriodIds: input.servicePeriodIds } : {},
		sort: ["startsAt", Sort.Asc],
		startsAt: { lt: startsAtLt }
	};
}
//#endregion
export { buildVisibleRangeQuery };

//# sourceMappingURL=build-visible-range-query.js.map